import { render, staticRenderFns } from "./BackDialog.vue?vue&type=template&id=73896032"
import script from "./BackDialog.vue?vue&type=script&lang=js"
export * from "./BackDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.23_cache-loader@4.1.0_webpack@4.47.0_webpack-cli@3.3_rzr6sqiw3iaxcjpfollk37er5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports